import React from 'react';
import { Trans } from 'react-i18next';
import Loadable from 'react-loadable';
import Logout from './views/logout';
import Profile from './views/profile';
import Social from './views/social';
import Loading from './components/Loading';
import Messages from './views/modules/messages';
import Blog from './views/modules/blog';
import KnowledgeBase from './views/modules/kb';
import Feedback from './views/modules/feedback';
import FeedbackAddNew from './views/modules/feedback/feedbackItem/addNew';
import FeedbackExt from './views/modules/feedback/feedbackItem/ext';
import Ticket from './views/modules/ticket';
import SimplePage from './views/modules/simplePage';
import CalendlyPage from './views/modules/calendlyPage';
import Documents from './views/modules/documents';
import MyDocuments from './views/modules/documents/mydocs';
import StripeInvoices from './views/modules/stripeInvoices';
import ModuleService from './services/module.service';
import Gallery from './views/modules/gallery';

const Dashboard = Loadable({
  loader: () => import('./views/dashboard'),
  loading: Loading,
});

const getRoutes = (onlyForModules = false) => {
  const routes = [
    {
      path: '/',
      exact: true,
      name: (<Trans>Home</Trans>),
      isPublic: true,
    },
    {
      path: '/dashboard',
      exact: true,
      component: Dashboard,
      permissions: [],
      isPublic: true,
    },
    {
      path: '/profile',
      exact: true,
      component: Profile,
      permissions: [],
    },
    {
      path: '/social-logged',
      exact: true,
      component: Social,
      permissions: [],
    },
    {
      path: '/messages',
      exact: false,
      component: Messages,
      permissions: [],
      name: (<Trans>Messenger</Trans>),
      module: ModuleService.TYPE_MESSAGE,
      moduleTitle: 1,
    },
    {
      path: '/blog',
      exact: false,
      component: Blog,
      name: (<Trans>Blog</Trans>),
      permissions: [],
      module: ModuleService.TYPE_BLOG,
      moduleTitle: 1,
      isPublic: true,
    },
    {
      path: '/kb',
      exact: false,
      permissions: [],
      name: (<Trans>Knowledge base</Trans>),
      component: KnowledgeBase,
      module: ModuleService.TYPE_KB,
      moduleTitle: 1,
      isPublic: true,
    },
    {
      path: '/feedback',
      exact: true,
      permissions: [],
      component: Feedback,
      name: (<Trans>Feedback</Trans>),
      module: ModuleService.TYPE_FEEDBACK,
      moduleTitle: 1,
      isPublic: true,
    },
    {
      path: '/feedback/add-new',
      exact: true,
      component: FeedbackAddNew,
      permissions: [],
      name: (<Trans>Feedback new</Trans>),
      child: true,
      module: ModuleService.TYPE_FEEDBACK,
    },
    {
      path: '/feedback/:id',
      exact: true,
      component: FeedbackExt,
      permissions: [],
      name: (<Trans>Feedback edit</Trans>),
      child: true,
      module: ModuleService.TYPE_FEEDBACK,
      isPublic: true,
    },
    {
      path: '/ticket',
      exact: false,
      permissions: [],
      component: Ticket,
      name: (<Trans>Tickets</Trans>),
      module: ModuleService.TYPE_TICKETS,
      moduleTitle: 1,
    },
    {
      path: '/page-:id',
      exact: true,
      permissions: [],
      child: true,
      component: SimplePage,
      name: (<Trans>Simple page</Trans>),
      module: ModuleService.TYPE_PAGE,
      isPublic: true,
    },
    {
      path: '/calendly',
      exact: true,
      permissions: [],
      child: false,
      component: CalendlyPage,
      name: (<Trans>Plan a meeting</Trans>),
      module: ModuleService.TYPE_CALENDLY_PAGE,
      isPublic: true,
    },
    {
      path: '/docs/folder/:folder_id',
      exact: false,
      permissions: [],
      component: Documents,
    },
    {
      path: '/docs',
      exact: false,
      permissions: [],
      component: Documents,
      name: (<Trans>Documents</Trans>),
      module: ModuleService.TYPE_DOCUMENTS,
      moduleTitle: 1,
      isPublic: true,
    },
    {
      path: '/my-docs',
      exact: false,
      permissions: [],
      component: MyDocuments,
      name: (<Trans>My documents</Trans>),
      module: ModuleService.TYPE_DOCUMENTS,
    },
    {
      path: '/gallery',
      exact: false,
      permissions: [],
      component: Gallery,
      name: (<Trans>Gallery</Trans>),
      module: ModuleService.TYPE_GALLERY,
      moduleTitle: 1,
      isPublic: true,
    },
    {
      path: '/stripe-invoices',
      exact: true,
      permissions: [],
      component: StripeInvoices,
      name: (<Trans>Stripe Invoices</Trans>),
      module: ModuleService.TYPE_STRIPE_INVOICES,
      moduleTitle: 1,
      isPublic: false,
    },
    {
      path: '/logout',
      exact: true,
      component: Logout,
      permissions: [],
    },
  ];
  if (onlyForModules) {
    return routes.filter(r => r.module).reduce((result, item) => {
      if (!result[item.module]) {
        result[item.module] = item;
      }
      return result;
    }, {});
  }
  return routes;
};

export default getRoutes;



// WEBPACK FOOTER //
// ./src/routes.js